var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewindFullIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 34,
    viewBox: "0 0 48 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_519_153",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 23.8L48.0001 34L48 -2.28882e-05L30 10.2V-2.28882e-05L4.95911e-05 17L30 34V23.8Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 23.8L48.0001 34L48 -2.28882e-05L30 10.2V-2.28882e-05L4.95911e-05 17L30 34V23.8Z",
    fill: "#DFF8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0001 34L46.521 36.6101L51.0001 39.1482L51.0001 34L48.0001 34ZM30 23.8L31.4791 21.1899L27 18.6518L27 23.8H30ZM48 -2.28882e-05H51L51 -5.14821L46.521 -2.61009L48 -2.28882e-05ZM30 10.2H27V15.3482L31.4791 12.81L30 10.2ZM30 -2.28882e-05H33L33 -5.14821L28.521 -2.61009L30 -2.28882e-05ZM4.95911e-05 17L-1.47899 14.3899L-6.08498 17L-1.47899 19.6101L4.95911e-05 17ZM30 34L28.521 36.6101L33 39.1482V34H30ZM49.4791 31.3899L31.4791 21.1899L28.521 26.4101L46.521 36.6101L49.4791 31.3899ZM45 -2.28882e-05L45.0001 34L51.0001 34L51 -2.28882e-05H45ZM31.4791 12.81L49.4791 2.61004L46.521 -2.61009L28.521 7.58992L31.4791 12.81ZM27 -2.28882e-05V10.2H33V-2.28882e-05H27ZM1.47909 19.6101L31.4791 2.61004L28.521 -2.61009L-1.47899 14.3899L1.47909 19.6101ZM31.4791 31.3899L1.47909 14.3899L-1.47899 19.6101L28.521 36.6101L31.4791 31.3899ZM27 23.8V34H33V23.8H27Z",
    fill: "#DFF8FF",
    mask: "url(#path-1-inside-1_519_153)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewindFullIcon);
export default __webpack_public_path__ + "static/media/rewind-full-icon.2882cf79ec19f4314213c81e4111d998.svg";
export { ForwardRef as ReactComponent };